var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "screenCard" }, [
    _c("div", { staticClass: "screenCard-title" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
    ]),
    _c(
      "div",
      { staticClass: "screenCard-slot", style: _vm.slotStyleCSS },
      [_vm._t("container")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }